
import * as React from "react";
import { useReactToPrint } from "react-to-print";

const getThermalPageStyle = () => `
  @page {
    size: auto;
    margin: 0;
  }

  /* Main thermal receipt container */
  #thermalPrint {
    width: 80mm;
    margin: 0;
    padding: 4mm;
    box-sizing: border-box;
    font-family: 'Courier New', monospace;
    font-size: 12pt;
    color: #000;
    line-height: 1.5;
    text-align: left;
  }

  /* Logo - force to pure black */
  #thermalPrint img.logo {
    display: block;
    max-width: 100%;
    height: auto;

    /* Convert to black and white */
    filter: grayscale(100%) brightness(0) contrast(200%);
  }
/* Table styling */
table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12pt;
  text-align: left;
}

th, td {
  padding: 6px 4px;
  color: #000;
  word-wrap: break-word;
  word-break: break-word;
}

th {
  font-weight: bold;
  background-color: #f2f2f2;
  white-space: nowrap;
  text-align: left;
}

/* Product name column */
td.product-name {
  width: 50%;
  white-space: normal;
}
/* Number columns */
td.qty, td.rate, td.total {
  width: auto;               /* let them grow if needed */
  min-width: 16%;            /* keep some balance */
  white-space: nowrap;       /* prevent wrapping */
  text-align: right;         /* align numbers to the right */
  padding-right: 6px;        /* extra padding for big numbers */
  overflow: visible;         /* prevent clipping */
}
/* Totals row styling */
tr.total-row td.label {
  text-align: left;
  font-weight: bold;
  font-size: 12pt;
  padding: 6px 4px;
  white-space: normal;   /* allow wrapping if label is long */
}

tr.total-row td.value {
  text-align: right;
  font-weight: bold;
  font-size: 13pt;
  padding: 6px 4px;
  white-space: nowrap;   /* prevent big numbers from breaking */
  overflow: visible;
}

/* Totals row */
tr.total-row td {
  font-weight: bold;
  font-size: 13pt;
  border-top: 2px solid #000;
  padding: 8px 4px;
  text-align: right;
  white-space: nowrap;       /* prevent wrapping in totals */
}

/* Row borders */
tr td {
  border-bottom: 1px solid #000;
}

tr:last-child td {
  border-bottom: 2px solid #000;
}


  /* Print mode */
  @media print {
    html, body {
      margin: 0;
      padding: 0;
      width: 80mm;
      display: block;
      text-align: left;
    }

    button, .no-print {
      display: none;
    }
  }
`;


function useThermalPrint(title, onAfterPrint) {
  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: title,
    pageStyle: getThermalPageStyle,
    onAfterPrint,
  });

  return { componentRef, handlePrint };
}

export { useThermalPrint };
